import { useCallback } from 'react';

export const useScrollToElement = (
    ref: React.RefObject<Element>,
    scrollBehavior: ScrollBehavior | undefined = undefined,
) => {
    const scrollToElement = useCallback(() => {
        ref?.current?.scrollIntoView({
            behavior: scrollBehavior,
        });
    }, [ref, scrollBehavior]);

    return {
        scrollToElement,
    };
};
